import React from "react";
import {Link} from "react-router-dom";

import "../../../style/PriorityTableStyles/lovdataLink.css";

export default function LovdataLink({lovdataUrl}: { lovdataUrl: string }) {
    return (
        <>
            {lovdataUrl &&
                <Link
                    to={process.env.REACT_APP_LOVDATA_BASE_URL + lovdataUrl}
                    className="lovdata-link"
                    target={"_blank"}>
                    <img src={"/lovdata-pro.svg"} className="lovdata-logo" alt="lovdata logo"/>
                    <span className="lovdata-link-text">Gå til</span>
                </Link>
            }
        </>
    );
}
